import BlockIcon from "@mui/icons-material/Block";
import { nacidRequests } from "api/nacidApi";
import { TextInput, required, useNotify, useRecordContext, useRefresh } from "react-admin";
import dataProvider from "server/dataProvider";
import FormModal from "server/components/Modals/FormModal";
import { Button } from "@mui/material";

// Cancelling abandons a reportable event: nothing is sent to NACID and the register stays short of it until
// someone does something else about it. That is why the note is mandatory — it is the only record of why.
const CancelFlowDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record) return null;

  const handleConfirm = async data => {
    await dataProvider.customRequest(nacidRequests.cancelFlow(record.id), { note: data.note }, "POST");

    notify("Потокът е отказан.", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      onConfirm={handleConfirm}
      titleContent="Отказ на потока"
      saveTitle="Откажи потока"
      dialogSize="md"
      triggerButton={
        <Button
          label="Откажи"
          startIcon={<BlockIcon />}
        />
      }
    >
      <TextInput
        source="note"
        label="Причина за отказа"
        validate={[required()]}
        multiline
        rows={3}
        fullWidth
        helperText="Събитието няма да бъде подадено към НАЦИД. Опишете защо."
      />
    </FormModal>
  );
};

export default CancelFlowDialog;
